module.exports = __webpack_public_path__ + "static/media/fo.c2f63475.svg";